import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) return;
    if (!localStorage.getItem("midhq_token")) {
      setUser(false);
      return;
    }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {
      localStorage.removeItem("midhq_token");
      setUser(false);
    });
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("midhq_token", data.token);
    setUser(data.user);
    return data.user;
  }, []);

  const register = useCallback(async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("midhq_token", data.token);
    setUser(data.user);
    return data.user;
  }, []);

  const googleLogin = useCallback(async (session_id) => {
    const { data } = await api.post("/auth/google", { session_id });
    localStorage.setItem("midhq_token", data.token);
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    localStorage.removeItem("midhq_token");
    setUser(false);
  }, []);

  return <AuthCtx.Provider value={{ user, login, register, googleLogin, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
